import { Box, Flex, Heading } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useDocumentsViewModel } from '../../models/DocumentsViewModel';
import { DocumentLink } from '../../../types';

type DocumentProps = {
  document: DocumentLink;
};

const Document: React.FC<DocumentProps> = ({ document }) => {
  return (
    <Flex
      mb="20px"
      as={Link}
      target="_blank"
      to={document.link}
      alignItems={'center'}
      justifyContent={'space-between'}
      cursor="pointer"
      borderColor="black"
      borderRadius="10px"
      borderStyle={'solid'}
      borderWidth="1px"
      padding="20px"
      shadow="0px 4px 6px -1px #00000011"
      w="full">
      <TextBlock weight="bold">{document.title}</TextBlock>
      <Icon variant="regular" icon="link-simple" />
    </Flex>
  );
};

export const CashFlow: React.FC = () => {
  const documentsViewModel = useDocumentsViewModel();

  return (
    <Box w="100%" p="24px">
      <Heading lineHeight={1} fontWeight="normal" fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
        Cash Flow
      </Heading>
      <TextBlock fontSize="14px" mt="8px" mb="24px">
        Concreit Fund I LLC
      </TextBlock>
      <Box display="grid" gridTemplateColumns={['100%', '100%', '50% 50%']} gap="10px" flexWrap={'wrap'} w="full">
        {documentsViewModel.cashFlowDocs.map((document, i) => (
          <Box key={`cash-flow-${i}`} w={['full']}>
            <Document document={document} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
